import { Icon, type IconProps } from "@chakra-ui/react"
import { memo } from "react"
import { useNavigate } from "react-router-dom"

export const Logo = memo((props: IconProps) => {
	const navigate = useNavigate()

	return (
		<Icon
			onClick={() => navigate("/")}
			fill="none"
			viewBox="0 0 123 40"
			width="1em"
			height="1em"
			_hover={{ cursor: "pointer" }}
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M20.075 1.917C10.05 1.917 1.921 10.01 1.921 20c0 9.989 8.13 18.083 18.154 18.083 10.025 0 18.154-8.094 18.154-18.083 0-9.986-8.13-18.083-18.154-18.083zM.08 20C.08 8.998 9.034.083 20.075.083S40.07 9.001 40.07 20c0 11.002-8.954 19.917-19.995 19.917S.08 31.002.08 20z"
				clipRule="evenodd"
			/>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M27.968 15.255l-5.043-.21 3.427-3.696-1.38-1.372-3.715 3.404-.203-5.025h-1.947l-.21 5.025-3.711-3.415-1.377 1.376 3.42 3.7-5.047.198v1.943l5.043.21-3.427 3.696 1.38 1.372 3.656-3.352.162 8.141-2.92.213v1.808l2.965.223.055 2.828h1.947l.06-2.824 2.992-.227v-1.808l-2.949-.213.166-8.137 3.652 3.355 1.377-1.372-3.416-3.7 5.043-.201v-1.94zM77.27 29.37c-.891.503-1.969.762-3.27.762-3.084 0-4.57-1.77-5.21-3.546-.497-1.377-.505-2.295-.505-3.058V14.03h4.482v9.298c0 1.548.951 2.94 2.824 2.94 1.873 0 3.24-1.326 3.24-2.755V14h4.445v15.688H79.41l-.453-1.932c-.223.54-.766 1.073-1.68 1.613M90.76 14.09l.52 2.213c1.115-1.585 2.445-2.466 4.035-2.658 3.085-.377 5.21.977 6.095 2.784.476.977.698 2.657.698 5.026v8.225H97.82v-8.41c0-2.783-.795-3.857-3.21-3.857-1.554 0-3.115 1.644-3.115 4.464v7.818h-4.288V14.089h3.553zm26.852 7.72c0 1.363-.416 2.466-1.241 3.288a3.928 3.928 0 01-2.921 1.236 4.14 4.14 0 01-1.739-.37l5.678-5.656c.149.459.223.962.223 1.503zm-8.354 0c0-1.295.416-2.339 1.241-3.197.855-.852 1.844-1.267 2.951-1.267.632 0 1.226.134 1.769.408l-5.723 5.7a5.456 5.456 0 01-.238-1.643zM123 14.719l-2.363-2.354-2.549 2.54c-1.353-.926-2.914-1.377-4.668-1.377-2.348 0-4.318.792-5.938 2.406-1.62 1.613-2.416 3.546-2.416 5.855 0 1.762.461 3.317 1.398 4.701l-2.275 2.266 2.364 2.354 2.252-2.243c1.338.918 2.869 1.37 4.615 1.37 2.319 0 4.289-.822 5.909-2.503 1.62-1.68 2.415-3.635 2.415-5.945 0-1.702-.431-3.19-1.308-4.508L123 14.726v-.008zM59.983 9.47v12.659c0 2.369-1.367 3.798-3.144 3.798-1.33 0-2.423-.777-3.225-2.658l-3.999 2.28c1.383 3.11 3.962 4.679 7.7 4.679 2.066 0 3.813-.792 5.18-2.34 1.368-1.584 2.066-3.575 2.066-5.944L64.48 9.477h-4.496V9.47z"
				clipRule="evenodd"
			/>
		</Icon>
	)
})
